module.exports = __webpack_public_path__ + "img/play_for_real.de322c19.png";